import React from 'react';
import UserCard from '../chat/UserCard';

const ListOfUser = ({ users, handleSelectedChat, selectedUser, formatChatTime }: any) => {
  return (
    <div className="flex flex-col gap-2.5 xl:h-[calc(100vh-224px)] xl:overflow-y-auto p-2 pr-2.5">
      {users.map((user: any) => (
        <UserCard
          key={user.id}
          user={user}
          handleSelectedChat={handleSelectedChat}
          selectedUser={selectedUser}
          formatChatTime={formatChatTime}
        />
      ))}
    </div>
  );
};

export default ListOfUser;
